import React from "react";

const AttachmentPreview = ({ attachments, onDelete }) => {
  const renderPreview = (file) => {
    const fileUrl = `https://loopsneller.com/${file.file_path}`;
    const fileExt = file.file_name.split(".").pop().toLowerCase();

    const deleteButton = onDelete ? (
      <button
        className="btn btn-sm btn-link text-danger p-0 ms-2"
        onClick={() => onDelete(file.id)}
        title="Delete attachment"
      >
        🗑️
      </button>
    ) : null;

    if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileExt)) {
      return (
        <div className="mb-2">
          <div className="d-flex align-items-center justify-content-between">
            <img
              src={fileUrl}
              alt={file.file_name}
              className="img-thumbnail"
              style={{ maxWidth: "200px", maxHeight: "200px" }}
            />
            {deleteButton}
          </div>
        </div>
      );
    }

    if (fileExt === "pdf") {
      return (
        <div className="mb-2">
          <iframe
            src={fileUrl}
            title={file.file_name}
            style={{ width: "100%", height: "300px", border: "1px solid #ccc" }}
          />
          <div className="d-flex justify-content-between align-items-center mt-1">
            <a
              href={fileUrl}
              download
              className="btn btn-sm btn-outline-primary"
            >
              Download PDF
            </a>
            {deleteButton}
          </div>
        </div>
      );
    }

    // Fallback for other file types
    return (
      <div className="mb-2 d-flex justify-content-between align-items-center">
        📎{" "}
        <a href={fileUrl} target="_blank" rel="noopener noreferrer">
          {file.file_name}
        </a>
        {deleteButton}
      </div>
    );
  };

  return (
    <div className="mt-2">
      {attachments.map((file) => (
        <div key={file.id}>{renderPreview(file)}</div>
      ))}
    </div>
  );
};

export default AttachmentPreview;
